export default "__VITE_ASSET__BlsMLxXh__"